if (!customElements.get('wls-steps')) {
    class WLSSteps extends HTMLElement {
        constructor() {
            super();
            this.classes = {
                swiper: 'js-wls-steps',
                list: 'swiper-wrapper',
                item: 'swiper-slide',
                navigation: {
                    pagination: 'js-wls-steps-pagination'
                },
            };

            this.elements = {
                slider: this.querySelector(`.${this.classes.swiper}`),
                list: this.querySelector(`.${this.classes.list}`),
                items: this.querySelectorAll(`.${this.classes.item}`),
                navigation: {
                    pagination: this.querySelector(`.${this.classes.navigation.pagination}`)
                }
            };

            this.resizeHandler = this.handleResize.bind(this);
        }

        connectedCallback() {
            if (this.checkIfEmpty()) return;
            this.init();
            window.addEventListener('resize', this.resizeHandler);
        }

        disconnectedCallback() {
            if (this.swiper) {
                this.swiper.destroy();
            }
            window.removeEventListener('resize', this.resizeHandler);
            if (this.resizeTimeout) {
                clearTimeout(this.resizeTimeout);
            }
        }

        checkIfEmpty() {
            const listInner = this.elements.list;
            if (!listInner || !listInner.children.length) {
                this.style.display = 'none';
                return true;
            }
            return false;
        }

        init() {
            if (!this.shouldInitialize()) return;
            this.initializeSwiper();
        }

        shouldInitialize() {
            if (!this.elements.slider || !this.elements.items.length) return false;
            const slidesCount = this.elements.items.length;
            const width = window.innerWidth;
    
            if (slidesCount <= 1 && width < 1200) return false;
            if (width >= 1200) return false;
    
            return true;
        }

        handleResize() {
            if (this.resizeTimeout) {
                clearTimeout(this.resizeTimeout);
            }
    
            this.resizeTimeout = setTimeout(() => {
                const shouldInit = this.shouldInitialize();
    
                if (shouldInit && !this.swiper) {
                    this.initializeSwiper();
                } else if (!shouldInit && this.swiper) {
                    this.swiper.destroy(true, true);
                    this.swiper = null;
                }
            }, 300);
        }

        initializeSwiper() {
            
            this.swiper = new Swiper(this.elements.slider, {
                slidesPerView: 1,
                spaceBetween: 16,
                pagination: {
                    el: this.elements.navigation.pagination,
                    clickable: true,
                },
            });

        }
    }

    customElements.define('wls-steps', WLSSteps);
}
